import React from "react";
import { Grid, GridProps } from "@mui/material";

type CellProps = {
  children: any;
  sx?: any;
} & GridProps;

export const TableCell = ({ children, sx, ...other }: CellProps) => {
  return (
    <Grid
      item
      sx={{ fontSize: 14, textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center", ...sx }}
      {...other}
    >
      {children}
    </Grid>
  );
};
